import requestCtm from '@/utils/request-ctm';

/**
 * 主页新闻列表数据
 * category 1公司新闻 2行业动态
 * @param {*} params
 */
export function getNewList(p = {}) {
  return requestCtm('/public/queryWebsiteNews', { params: {
    pageNum: p.pageNum,
    pageSize: p.pageSize,
    search_EQ_srcWebsite: 0,
    search_EQ_category: p.category,
    sortDir: "desc",
    sortType: "publishTime"
  } });
}

/**
 * 获取新闻详情
 * @param {*} params
 */
export function getNewDetail(id) {
    return requestCtm(`/public/getNewsById?id=${id}`);
}

